import {Injectable} from "@angular/core";
import {MvsCrudService} from "../crud/mvs-crud.service";
import {DtoDetail} from "../../dto/dto.detail";
import {Observable} from "rxjs";
import {DeleteResponseDto} from "../../dto/delete-response.dto";

@Injectable({ providedIn: 'root' })
export abstract class MvsApiCrudOnlyReadService extends MvsCrudService{


  override create(dto: DtoDetail): Observable<DtoDetail> {
        console.assert(true,"Not supported!");
        return null;
    }

  override delete(id: number): Observable<DeleteResponseDto> { // TM-1000001714
        console.assert(true,"Not supported!");
        return null;
    }

  override update(dto: DtoDetail): Observable<DtoDetail> {
        console.assert(true,"Not supported!");
        return null;
    }
}
